import type { ResetPassword } from 'models';
import { apiClient, routes } from 'common/services';

export const resetPassword = async ({ currentPassword, email, password, resetPasswordToken }: ResetPassword) => {
  const data = {
    user: {
      current_password: currentPassword,
      email,
      password,
      reset_password_token: resetPasswordToken,
    },
  };

  return apiClient.put(routes.user.password, data, { skipAuth: true });
};
